import { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { queryClient } from "../services/QueryClientService";
import { LoginModel } from "../models/LoginModel";
import { ResumoClienteModel } from "../models/ResumoClienteModel";
import { screens } from "../config/screens";

type AuthContextProps = {
	user: LoginModel | undefined;
	cliente: ResumoClienteModel | undefined;
	routeActive: string;
	handleLogin: (user: LoginModel) => void;
	handleLogout: () => void;
	handleCliente: (cliente: ResumoClienteModel) => void;
};

const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export function useAuth() {
	return useContext(AuthContext);
}

type AuthProviderProps = {
	children: ReactNode;
};

const locations = screens.map((screen) => {
	return screen.route;
});

export default function AuthProvider({ children }: AuthProviderProps) {
	const location = useLocation();
	const navigate = useNavigate();

	const [loading, setLoading] = useState(true);
	const [user, setUser] = useState<LoginModel>();
	const [cliente, setCliente] = useState<ResumoClienteModel>();
	const [routeActive, setRouteActive] = useState<string>("");

	useEffect(() => {
		if (locations.includes(location.pathname)) {
			setRouteActive(location.pathname);
		}
	}, [location]);

	useEffect(() => {
		let sessionUser = sessionStorage.getItem("user");
		if (sessionUser) {
			let userJson = JSON.parse(sessionUser);
			let user = new LoginModel(userJson);
			setUser(user);
		}

		let sessionCliente = sessionStorage.getItem("cliente");
		if (sessionCliente) {
			let clienteInt = JSON.parse(sessionCliente);
			setCliente(clienteInt);
		}

		setLoading(false);
	}, []);

	async function handleLogin(user: LoginModel) {
		sessionStorage.setItem("user", JSON.stringify(user));
		setUser(user);
	}

	function handleLogout() {
		setUser(undefined);
		setCliente(undefined);
		sessionStorage.removeItem("user");
		sessionStorage.removeItem("cliente");
		queryClient.invalidateQueries();
		navigate("/");
		return;
	}

	async function handleCliente(cliente: ResumoClienteModel) {
		sessionStorage.setItem("cliente", JSON.stringify(cliente));
		queryClient.invalidateQueries();
		setCliente(cliente);
	}

	const value = {
		user,
		cliente,
		routeActive,
		handleLogin,
		handleLogout,
		handleCliente,
	};

	if (loading) {
		return <></>;
	}

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
